import { action } from "mobx";
import { getToken } from "../infrastructure/Auth0Authenticator";
import {
  Client as AgentServiceClient,
  DownloadAgentsRequestModel,
  InviteAgentModel
} from "../services/AgentManagementService";
import UserContext from "../infrastructure/UserContext";
import ServiceClient from "../infrastructure/client/ServiceClient";
import { ServiceType } from "../infrastructure/enum/ThemeSettings";
import Utils from "../infrastructure/Utils";
import { googleTagManager } from '../infrastructure/tracking/';

class AgentManagementStore {
  getApiVersion = () => {
    return "1";
  };
  getApiKey = async (): Promise<string> => {
    var token = await getToken();
    return token ? `Bearer ${token}` : "";
  };

  getClient = (): AgentServiceClient => {
    return ServiceClient.getClient(ServiceType.AgentManagment);
  };

  getHostname = () => {
    return Utils.getServiceUrlByEnvironment();
  };


  @action getAllAgentDetailsAsync = async (
    searchType: string | undefined | null,
    searchKey: string,
    pageIndex: number,
    includeMetricsDetails: boolean,
    pageSize: number,
    sortColumn: string | undefined,
    sortAscending: boolean | undefined,
    searchConditions: string | undefined,
  ) => {
     googleTagManager.trackAction("agent_search_conducted", {
          feature: "Agents",
          user_id: UserContext.userId,
          search_text:searchKey,
      });
      var result = await this.getClient().getAllAgentDetailsAsync(
        this.getApiVersion(),
        searchType,
        searchKey,
        pageIndex,
        includeMetricsDetails,
        pageSize,
        sortColumn,
        sortAscending,
        searchConditions,
        UserContext.getUserId(),
        this.getHostname()
      );
      return result;
  };

  @action downloadAgents = async (request?: DownloadAgentsRequestModel | undefined) => {  
      var result = await this.getClient().downloadAgents(
        this.getApiVersion(),
        UserContext.getUserId(),
        undefined,
        request
      );
      return result;
  };

  @action upLineReporting = async (fullTextFilter: string) => {  
    var result = await this.getClient().getupLineReporting(
      this.getApiVersion(),
      fullTextFilter,
      UserContext.getUserId(),
      this.getHostname()
    );
    return result;
};

@action levelLookup = async () => {  
  var result = await this.getClient().getlevelLookup(
    this.getApiVersion(),
    Utils.getBUName(),
    this.getHostname()
  );
  return result;
};

@action inviteAgent = async (request?: InviteAgentModel | undefined) => {  
  var result = await this.getClient().inviteAgent(
    this.getApiVersion(),
    UserContext.getUserId(),
    this.getHostname(),
    request
  );
  return result;
};
}

export default new AgentManagementStore();
